// @flow

export const MENU_ITEMS_KEYS_AUTO_SERVICES = "AutoServices";
export const MENU_ITEMS_KEYS_MASS_LOAD = "MassLoad";
export const MENU_ITEMS_KEYS_MASS_LOAD_LISTS = "MassLoadList";
export const MENU_ITEMS_KEYS_MASS_LOAD_LISTS_EDIT = "MassLoadListEdit";
export const MENU_ITEMS_KEYS_MASS_LOAD_LISTS_TERMINATION =
	"MassLoadTerminationLists";
export const MENU_ITEMS_KEYS_MASS_LOAD_QUOTATIONS = "MassLoadQuotations";
export const MENU_ITEMS_KEYS_MASS_LOAD_BILLS = "MassLoadBills";
export const MENU_ITEMS_KEYS_MASS_LOAD_LIST_EDITOR = "MassLoadListEditor";
export const MENU_ITEMS_KEYS_MASS_EDIT = "MassEdit";
export const MENU_ITEMS_KEYS_MASS_TERMINATION = "MassTermination";
export const MENU_ITEMS_KEYS_MASS_DOWNLOAD_APP_TEMPLATE = "DownloadAppTemplate";

export const MENU_ITEMS_KEYS_COMPANY = "Company";
export const MENU_ITEMS_KEYS_COMPANY_SIGNATURE = "CompanySignature";

export const MENU_ITEMS_KEYS_INFO_PORTAL = "CompanyInfoPortal";
export const MENU_ITEMS_KEYS_OSGOPP_CONTRACTS = "OsgopContracts";
export const MENU_ITEMS_KEYS_OSOPO_CONTRACTS = "OsopoContracts";
export const MENU_ITEMS_KEYS_INSURANCE_CASE = "OsgopOsopoInsuranceCase";
export const MENU_ITEMS_KEYS_USER_MANAGEMENT = "ProfileManagement";
export const MENU_ITEMS_KEYS_POLICIES = "CompanyPolicies";
export const MENU_ITEMS_KEYS_REGISTER_CLAIMS = "RegisterClaims";
export const MENU_ITEMS_KEYS_REGISTER_CLAIM = "RegisterClaim";
export const MENU_ITEMS_KEYS_CLAIMS_LIST = "ClaimsList";
export const MENU_ITEMS_KEYS_ORDER_CLAIM_SERVICE = "OrderClaimService";
export const MENU_ITEMS_KEYS_PROFILE_MANAGEMENT = "ProfileManagement";
export const MENU_ITEMS_KEYS_NOTIFICATION_SETTINGS = "NotificationSettings";
export const MENU_ITEMS_KEYS_CLAIM_DOCUMENTS = "SubmitClaimDocuments";
export const MENU_ITEMS_KEYS_VEHICLE_FLEET = "VehicleFleet";
export const MENU_ITEMS_KEYS_POLICY_EDIT = "PolicyEdit";
export const MENU_ITEMS_KEYS_POLICY_TERMINATION = "PolicyTermination";

export const MENU_ITEMS_KEYS_REPORTS = 'OsagoReports';
export const MENU_ITEMS_KEYS_REPORTS_TABULAR_REPORT = 'TableReport';
export const MENU_ITEMS_KEYS_REPORTS_BALANCE_SHEET = 'BalanceReport';
export const MENU_ITEMS_KEYS_REPORTS_ANALYTICAL_REPORT = 'AnalyticalReport';
export const MENU_ITEMS_KEYS_KASKO_REPORTS = "KaskoReports";
export const MENU_ITEMS_KEYS_KASKO_REPORTS_UPLOAD_REPORT = "UploadReportView";


export const MENU_ITEMS_KEYS_TENDERS = "Tenders";
export const MENU_ITEMS_KEYS_TENDERS_TENDERS_LIST = "TendersList";
export const MENU_ITEMS_KEYS_TENDERS_TENDERS_EDIT_LISTS = "TendersEditLists";
export const MENU_ITEMS_KEYS_TENDERS_TENDERS_TERMINATION_LISTS =
	"TendersTerminationLists";
export const MENU_ITEMS_KEYS_TENDERS_TENDERS_QUOTATION_LISTS =
	"TendersQuotationLists";
export const MENU_ITEMS_KEYS_TENDERS_TENDERS_BILLS = "TendersBills";
export const MENU_ITEMS_KEYS_TENDERS_TENDERS_POLICIES = "TendersPolicies";
export const MENU_ITEMS_KEYS_TENDERS_TENDERS_PURCHASES = "TendersPurchases";

export const MENU_ITEMS_KEYS_GOV_CONTRACTS = "GovernmentContracts";
export const MENU_ITEMS_KEYS_GOV_CONTRACTS_LISTS = "GovernmentContractsList";
export const MENU_ITEMS_KEYS_GOV_CONTRACTS_QUOTATIONS =
	"GovernmentContractsQuotations";
export const MENU_ITEMS_KEYS_GOV_CONTRACTS_BILLS = "GovernmentContractsBills";

export const MENU_ITEMS_KEYS_COMPANY_HOME = "CompanyHome";

// Каско
export const MENU_ITEMS_KEYS_KASKO = "KaskoContracts";
export const MENU_ITEMS_KEYS_KASKO_POLICIES = "KaskoContractPolicy";
export const MENU_ITEMS_KEYS_KASKO_GENERAL_CONTRACTS = "GeneralContract";

const menuTypes = {
	MENU_ITEMS_FETCHED: "MENU_ITEMS_FETCHED",
	MENU_CONFIGURATION_CHANGED: "MENU_CONFIGURATION_CHANGED",
	RESPONSIBLE_FOR_RENDERING_ELEMENT_CHANGED:
		"RESPONSIBLE_FOR_RENDERING_ELEMENT_CHANGED",
};

//
const MY_INSURANCES = "MyInsurances";

// DMS
const DMS = {
	DMS_LPU: "DmsLpu",
	DMS_POLICY: "DmsPolicies",
	DMS_DEFAULT: "Dms",
	DMS_SERVICES: "DmsServices",
	DMS_CONTRACTS: "DmsContracts",
	DMS_SEND_REQUEST: "DmsSendRequest",
	DMS_NOTIFICATION: "DmsNotifications",
	DMS_MEDICAL_TYPES: "DmsInsuranceMedicalTypes",
	DMS_INSURANCE_PROGRAMS: "DmsInsurancePrograms",
	DMS_FRANCHISE: "DmsFranchise",
	DMS_FAMILY_INSURANCE: "DmsFamilyInsurance",
	DMS_UPGRADE_PROGRAM: "DmsUpgradeProgram",
	DMS_MEDICAL_CARE: "DmsMedicalAid",
	DMS_TELEMEDICINE: "DmsTelemedicine",
};

// ACCIDENT_INSURANCE
const ACCIDENT = {
	ACCIDENT_INSURED: "AccidentInsured",
	ACCIDENT_INSURED_CERTIFICATE: "AccidentCertificate",
	ACCIDENT_INSURED_REQUESTS: "AccidentRequest",
	ACCIDENT_ADMIN: "AccidentAdmin",
	ACCIDENT_CONTRACTS: "AccidentAdminContracts",
	ACCIDENT_CONTRACT: "AccidentAdminContract",
	ACCIDENT_CONTRACT_CERTIFICATES: "AccidentAdminCertificates",
	ACCIDENT_CONTRACT_REQUESTS: "AccidentAdminRequests",
	ACCIDENT_CONTRACT_DOCUMENTS: "AccidentAdminDocumentsList",
	ACCIDENT_ADMIN_MAILING: "AccidentAdminMailing",
};

const CLAIM = {
	CLAIM_HOME: MENU_ITEMS_KEYS_COMPANY_HOME,
	CLAIM_PROFILE: "Profile",
	CLAIM_CLIENTS: "CompanyClients",

	CLAIM_REGISTER: MENU_ITEMS_KEYS_REGISTER_CLAIMS,
	CLAIM_REGISTER_LIST: MENU_ITEMS_KEYS_CLAIMS_LIST,

	CLAIM_CONTRACTS: "CompanyContracts",
	CLAIM_INFO_PORTAL: MENU_ITEMS_KEYS_INFO_PORTAL,
	CLAIM_ORDER_SERVICE: MENU_ITEMS_KEYS_ORDER_CLAIM_SERVICE,
	CLAIM_SERVICE_LIST: "ClaimServiceList",
	CLAIM_COMPANY_POLICIES: MENU_ITEMS_KEYS_REGISTER_CLAIM,
	CLAIM_REGISTER_ONE_CLAIM: MENU_ITEMS_KEYS_POLICIES,
	CLAIM_COMPANY_CLIENT_CONTRACTS: "CompanyClientContracts",

	CLAIM_PROFILE_DOCUMENTS: "ProfileDocuments",

	CLAIM_OSGOPP_CONTRACTS: MENU_ITEMS_KEYS_OSGOPP_CONTRACTS,
	CLIME_OSOPO_CONTARCTS: MENU_ITEMS_KEYS_OSOPO_CONTRACTS,
	CLAIM_INSURANCE_CASE: MENU_ITEMS_KEYS_INSURANCE_CASE,
	CLAIM_USER_MANAGEMENT: MENU_ITEMS_KEYS_USER_MANAGEMENT,
};

// PROFILE

const PROFILE = {
	PROFILE: "Profile",
	USER_MANAGEMENT: "ProfileManagement",
	NOTIFICATION_SETTINGS: "Profile",
};

const AUTO_SERVICES = MENU_ITEMS_KEYS_AUTO_SERVICES;
const AUTO_SERVICES_JURIDICAL = "AutoServicesUL";

const MENU_ITEMS_KEYS = {
	MY_INSURANCES,
	DMS,
	ACCIDENT,
	CLAIM,
	PROFILE,
	AUTO_SERVICES,
	AUTO_SERVICES_JURIDICAL,
};

export { menuTypes, MENU_ITEMS_KEYS };
